import Navbar from "./components/Navbar";
import Home from "./views/Home"
import Following from "./views/Following"
import Sidebar from "./components/Sidebar";
import {BrowserRouter as Router,Switch,Route} from "react-router-dom";
import {isMobile} from 'react-device-detect';

function App() {
  return (
      <div className="App container-fluid">
        <Router>
          <Navbar isMobile={isMobile} />
          <div className="row">
            <Sidebar isMobile={isMobile} />
            <Switch>
              <Route exact path="/">
                <Home isMobile={isMobile} />
              </Route>
              <Route path="/following">
                <Following isMobile={isMobile} />
              </Route>
            </Switch>
          </div>
        </Router>
      </div>
  )
}

export default App